import React from 'react';
import { Link } from 'react-router-dom';
import { urlGiocatore, urlSquadra, urlEdizione, urlPartita } from '../../pages/statistiche/links';
import './Link.css';

/**
 * Rendere navigabile un nome deve costare una sostituzione di testo, non una riga di routing:
 * per questo i quattro componenti prendono gli stessi campi che le pagine hanno già in mano.
 * Quando manca il dato per costruire l'indirizzo si degrada a testo semplice invece di produrre
 * un link rotto.
 *
 * Usano la classe `stat-link-nome` e non `stat-link`: nominano una entità dentro un elenco o una
 * tabella, dove intere colonne sono fatte di link e la sottolineatura piena del browser
 * renderebbe la pagina illeggibile. Il link in mezzo alla prosa resta `stat-link`.
 */

export const LinkGiocatore = ({ id, nome, cognome, children, className = '' }) =>
  id ? <Link className={`stat-link-nome ${className}`} to={urlGiocatore(id, nome, cognome)}>{children ?? `${nome} ${cognome}`}</Link>
     : <span className={className}>{children ?? `${nome} ${cognome}`}</span>;

/**
 * Lo slug della squadra arriva dal server e non si ricostruisce qui: la squadra è la sua riga in
 * squadra_storica, e il client non sa quale sia. Chi non ne ha una non ha un indirizzo, quindi il
 * nome si legge e non si clicca — che è esattamente il comportamento di prima quando il nome era
 * vuoto.
 */
export const LinkSquadra = ({ slug, nome, children, className = '' }) =>
  slug ? <Link className={`stat-link-nome ${className}`} to={urlSquadra(slug)}>{children ?? nome}</Link>
       : <span className={className}>{children ?? nome}</span>;

export const LinkEdizione = ({ id, children, className = '' }) =>
  id ? <Link className={`stat-link-nome ${className}`} to={urlEdizione(id)}>{children}</Link>
     : <span className={className}>{children}</span>;

export const LinkPartita = ({ idEdizione, idPartita, children, className = '' }) =>
  idEdizione && idPartita
    ? <Link className={`stat-link-nome ${className}`} to={urlPartita(idEdizione, idPartita)}>{children}</Link>
    : <span className={className}>{children}</span>;
